import { base64Encoder } from '@aws-amplify/core/internals/utils';

// PKCE (RFC 7636) requires unpadded base64url - base64Encoder's urlSafe option
// swaps the '+'/'/' characters but doesn't strip the trailing '=' padding.
const toBase64Url = (input: Uint8Array): string =>
    base64Encoder.convert(input, { urlSafe: true }).replace(/=+$/, '');

export const generateCodeVerifier = (): string =>
    toBase64Url(crypto.getRandomValues(new Uint8Array(32)));

export const generateCodeChallenge = async (verifier: string): Promise<string> => {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
    return toBase64Url(new Uint8Array(digest));
};
